/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { H2, Flex, Box } from '@lucidhq/lucidium';

import { ROUTES } from '~/constants';
import { Page } from '~/impact-measurement/components';
import { PageContentWrapper } from '~/impact-measurement/components';
import { IM_FLAGS } from '~/impact-measurement/constants';
import { useSplit } from '~/impact-measurement/hooks';
import { useProfile } from '~/impact-measurement/utils/auth';
import { t } from '~/utils/i18n';

import { usePermissions } from '../Permissions/PermissionsProvider';
import { HomeCards } from './HomeCards';

export const Home = () => {
  const profile = useProfile();
  const history = useHistory();
  const {
    isLoading,
    permissions,
    isImt,
    isTrackingOnlyUser,
    isSuperAdmin
  } = usePermissions();
  //@NOTE: once available to all customers please remove this flag reference
  const { isOn } = useSplit(IM_FLAGS.CONNECT_TAG);

  const name = profile.name || profile.username || profile.email;

  if (isLoading) return null;

  useEffect(() => {
    if (isOn && isImt && isTrackingOnlyUser && !isSuperAdmin) {
      window.location.pathname = ROUTES.imAdminCampaigns;
      return;
    }

    if (isImt && !permissions.admin && !isTrackingOnlyUser) {
      return history.push('/impact-measurement');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissions, isLoading, isOn, isTrackingOnlyUser]);

  return (
    <Page hideProductName>
      <PageContentWrapper>
        <Box lss={{ my: 'xl', tablet: { mb: 'xxxl' } }}>
          <H2 lss={{ textAlign: 'center' }}>{t('home.welcome', { name })}</H2>
        </Box>

        <Flex
          lss={{
            height: 'auto',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            tablet: {
              height: '320px',
              flexDirection: 'row',
              alignItems: 'stretch'
            }
          }}
        >
          <HomeCards />
        </Flex>
      </PageContentWrapper>
    </Page>
  );
};
